/* GoChess x Harry Potter landing page.
   One file for every section. Everything is keyed off elements that may or may not be
   on the page, so a merchant can drop any section without breaking the rest, and boot()
   is idempotent so the theme editor can re-render a single section at a time.

   The product columns of the comparison table come from that section's own blocks, as
   JSON. The spec rows below are the only content that is not editable in the theme
   editor: they are a 6-column x 2-unit-system matrix, which does not fit Shopify's
   block settings sensibly. Edit them here. */
(function () {
  'use strict';
  if (window.__gcwLP) { window.__gcwLP.boot(); return; }

  /* ---------- spec matrix ---------- */
  var U = function (m, i) { return { m: m, i: i }; };
  var MINI_SIZE   = U(['33.3 × 33.3 cm', ''], ['13.1 × 13.1 in', '']);
  var MINI_SQ     = U(['35 × 35 mm', ''], ['1.38 × 1.38 in', '']);
  var THIN        = U(['0.87 cm', ''], ['0.34 in', '']);
  var MINI_KINGH  = U(['8.3 cm', ''], ['3.27 in', '']);
  var MINI_KINGW  = U(['26 g', ''], ['0.92 oz', '']);
  var MINI_BOARDW = U(['1.2 kg', 'board + pieces'], ['2.6 lb', 'board + pieces']);
  var ABS_BOARD   = ['High-quality ABS frame', 'Heavy-duty matte-finish board surface'];
  var CLEAN_VINYL = ['Weighted premium clean vinyl', 'High-density ABS'];

  /* keys must match the "Spec key" setting on each product block */
  var SPECS = [
    { g: 'Board & pieces', rows: [
      { label: 'Board size', vals: {
        alive: U(['50 × 50 cm', ''], ['19.7 × 19.7 in', '']),
        lite:  U(['48.3 × 48.3 cm', ''], ['19 × 19 in', '']),
        mini: MINI_SIZE, go_modern: MINI_SIZE, go_mini: MINI_SIZE, go_classic: MINI_SIZE } },
      { label: 'Board class', vals: {
        alive: ['Full size', 'Self-moving'], lite: ['Full size', 'Tournament size'],
        mini: ['Compact size', ''], go_modern: ['Compact size', ''],
        go_mini: ['Compact size', ''], go_classic: ['Compact size', ''] } },
      { label: 'Square size', vals: {
        alive: U(['48 × 48 mm', ''], ['1.89 × 1.89 in', '']),
        lite:  U(['48 × 48 mm', ''], ['1.89 × 1.89 in', '']),
        mini: MINI_SQ, go_modern: MINI_SQ, go_mini: MINI_SQ, go_classic: MINI_SQ } },
      { label: 'Thickness', vals: {
        alive: U(['4.8 cm', ''], ['1.89 in', '']),
        lite: THIN, mini: THIN, go_modern: THIN, go_mini: THIN, go_classic: THIN } },
      { label: "King's height", vals: {
        alive: U(['9.65 cm', ''], ['3.8 in', '']), lite: U(['9.6 cm', ''], ['3.78 in', '']),
        mini: MINI_KINGH, go_modern: MINI_KINGH, go_mini: MINI_KINGH, go_classic: MINI_KINGH } }
    ] },
    { g: 'Materials & weight', rows: [
      { label: 'Board material', vals: {
        alive: ABS_BOARD, lite: ABS_BOARD, mini: ABS_BOARD,
        go_modern: ABS_BOARD, go_mini: ABS_BOARD, go_classic: ABS_BOARD } },
      { label: 'Pieces material', vals: {
        alive: ['Premium vinyl over high-density matte-textured ABS', 'Steel weights and magnets'],
        lite: CLEAN_VINYL, mini: CLEAN_VINYL,
        go_modern: CLEAN_VINYL, go_mini: CLEAN_VINYL, go_classic: CLEAN_VINYL } },
      { label: "King's weight", vals: {
        alive: U(['35 g', ''], ['1.23 oz', '']), lite: U(['34 g', ''], ['1.2 oz', '']),
        mini: MINI_KINGW, go_modern: MINI_KINGW, go_mini: MINI_KINGW, go_classic: MINI_KINGW } },
      { label: 'Board weight', vals: {
        alive: U(['4.8 kg', 'board + robots'], ['10.6 lb', 'board + robots']),
        lite:  U(['2.6 kg', 'board + pieces'], ['5.7 lb', 'board + pieces']),
        mini: MINI_BOARDW, go_modern: MINI_BOARDW, go_mini: MINI_BOARDW, go_classic: MINI_BOARDW } }
    ] }
  ];

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var once = function (el, k) { if (el.dataset['gcw' + k]) return false; el.dataset['gcw' + k] = '1'; return true; };
  var soft = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches; };

  /* ---------- lazy video ---------- */
  var vio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        /* a poster is fetched eagerly even at preload=none, so it is held in data-poster
           and attached here, one rootMargin ahead of the clip itself */
        if (v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; }
        if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
        v.play().catch(function () {});
      }
      else v.pause();
    });
  }, { rootMargin: '250px 0px', threshold: 0.01 });

  /* ---------- stars ---------- */
  var STAR = '<svg viewBox="0 0 20 20"><defs><linearGradient id="gcwsg" x1="0" y1="0" x2="0" y2="1">' +
    '<stop offset="0" stop-color="#f9e78d"/><stop offset="1" stop-color="#ca9e48"/></linearGradient></defs>' +
    '<path fill="url(#gcwsg)" d="M10 1.6l2.5 5.2 5.7.8-4.1 4 1 5.7-5.1-2.7-5.1 2.7 1-5.7-4.1-4 5.7-.8z"/></svg>';

  /* ---------- infinite rail ---------- */
  function makeInfinite(track, opts) {
    opts = opts || {};
    var N = track.children.length;
    if (!N) return null;
    var before = document.createDocumentFragment(), after = document.createDocumentFragment();
    [].slice.call(track.children).forEach(function (node) {
      [before, after].forEach(function (frag) {
        var c = node.cloneNode(true);
        c.dataset.clone = '1';
        c.setAttribute('aria-hidden', 'true');
        $$('video', c).forEach(function (v) { v.preload = 'none'; vio.observe(v); });
        frag.appendChild(c);
      });
    });
    track.insertBefore(before, track.firstChild);
    track.appendChild(after);

    var rect = function (el) { return el.getBoundingClientRect(); };
    var posOf = function (el) { return rect(el).left - rect(track).left + track.scrollLeft; };
    var centreOf = function (el) { return posOf(el) - (track.clientWidth - rect(el).width) / 2; };
    var clamp = function (x) { return Math.max(0, Math.min(x, track.scrollWidth - track.clientWidth)); };
    var centred = function () {
      var mid = rect(track).left + track.clientWidth / 2, best = 0, bd = Infinity;
      [].slice.call(track.children).forEach(function (c, i) {
        var r = rect(c), d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    };
    var cur = ((opts.start || 0) % N + N) % N;
    var paint = function (i) {
      [].slice.call(track.children).forEach(function (c, k) { c.classList.toggle('is-mid', k === i); });
      if (opts.onMove) opts.onMove(((i % N) + N) % N);
    };
    function settle() {
      var i = centred();
      cur = ((i % N) + N) % N;
      if (i < N || i >= 2 * N) {
        var twin = track.children[N + cur];
        track.scrollLeft = clamp(centreOf(twin));
        paint(N + cur);
      }
      if (opts.onMove) opts.onMove(cur);
    }
    var raf = 0, busy = false;
    function glide(x, instant) {
      cancelAnimationFrame(raf);
      x = clamp(x);
      if (instant || soft()) { busy = false; track.style.scrollSnapType = ''; track.scrollLeft = x; return; }
      var from = track.scrollLeft, delta = x - from, t0 = performance.now(), dur = 420;
      if (Math.abs(delta) < 1) return;
      busy = true;
      track.style.scrollSnapType = 'none';
      var ease = function (p) { return 1 - Math.pow(1 - p, 3); };
      var tick = function (now) {
        var p = Math.min(1, (now - t0) / dur);
        track.scrollLeft = from + delta * ease(p);
        if (p < 1) { raf = requestAnimationFrame(tick); return; }
        track.style.scrollSnapType = ''; busy = false; settle();
      };
      raf = requestAnimationFrame(tick);
    }
    var goToChild = function (i, instant) {
      var el = track.children[i];
      if (!el) return;
      cur = ((i % N) + N) % N;
      glide(centreOf(el), instant);
      paint(i);
    };
    var goTo = function (logical, instant) {
      var l = ((logical % N) + N) % N;
      if (instant) return goToChild(N + l, true);
      var c = centred(), base = Math.floor(c / N) * N;
      var near = [base - N + l, base + l, base + N + l]
        .filter(function (i) { return i >= 0 && i < 3 * N; })
        .reduce(function (a, b) { return Math.abs(b - c) < Math.abs(a - c) ? b : a; });
      goToChild(near, false);
    };
    var t;
    track.addEventListener('scroll', function () {
      if (busy) return;
      paint(centred());
      clearTimeout(t); t = setTimeout(settle, 130);
    }, { passive: true });
    var onResize = function () { goTo(cur, true); };
    addEventListener('resize', onResize);
    requestAnimationFrame(function () { goTo(cur, true); });
    return {
      next: function () { goToChild(centred() + 1); },
      prev: function () { goToChild(centred() - 1); },
      goTo: goTo,
      teardown: function () {
        removeEventListener('resize', onResize); clearTimeout(t); cancelAnimationFrame(raf);
        track.style.scrollSnapType = '';
        $$('[data-clone]', track).forEach(function (n) { n.remove(); });
        $$('.is-mid', track).forEach(function (n) { n.classList.remove('is-mid'); });
      }
    };
  }

  /* ---------- comparison table ---------- */
  function buildCompare(sec) {
    var row = $('[data-sets-row]', sec), root = $('[data-tbl-root]', sec);
    var tag = $('[data-gcw-sets]', sec);
    if (!row || !root || !tag) return;
    var SETS;
    try { SETS = JSON.parse(tag.textContent); } catch (e) { return; }
    if (!SETS.length) return;

    /* Liquid resolves each column's price against the real Shopify product and leaves the
       result in this block, keyed by handle. Anything it does not cover (Wizard Alive, whose
       pre-order price is deliberately not the product's) keeps the price baked into SETS. */
    var pt = $('[data-gcw-prices]', sec), LIVE = {};
    if (pt) { try { LIVE = JSON.parse(pt.textContent) || {}; } catch (e) {} }
    SETS.forEach(function (s) {
      var m = /\/products\/([^/?#]+)/.exec(s.url || '');
      if (m && LIVE[m[1]]) s.price = LIVE[m[1]];
    });

    row.innerHTML = '<div class="pad" aria-hidden="true">&#8203;</div>' + SETS.map(function (s) {
      return '<div class="set' + (s.hi ? ' set--hi' : '') + '">' +
        '<h3>' + s.h + '</h3><p>' + s.p + '</p><p>SKU Name: ' + s.sku + '</p>' +
        '<img class="setimg" src="' + s.brd + '" alt="' + s.sku + ' board" width="900" height="578" loading="lazy">' +
        '<img class="setpcs" src="' + s.pcs + '" alt="" aria-hidden="true" width="900" height="319" loading="lazy">' +
        '</div>';
    }).join('');

    var unit = 'i';
    try { var st = localStorage.getItem('gc-units'); if (st === 'm' || st === 'i') unit = st; } catch (e) {}
    var cell = function (v, hi) {
      if (!v) v = ['', ''];
      var d = (v && v.m) ? v[unit] : v;
      return '<div class="tcell' + (hi ? ' hi' : '') + '">' +
        (d[0] ? '<b>' + d[0] + '</b>' : '') + (d[1] ? '<i>' + d[1] + '</i>' : '') + '</div>';
    };
    function render() {
      var html = '';
      SPECS.forEach(function (grp, gi) {
        html += '<button class="tgrp open" type="button" aria-expanded="true" aria-controls="gcwtb' + gi +
          '" data-g="' + gi + '"><b class="tgrp__t">' + grp.g + '</b><span></span></button>' +
          '<div class="tbody" id="gcwtb' + gi + '" data-b="' + gi + '">';
        grp.rows.forEach(function (r) {
          html += '<div class="trow"><div class="tcell lab">' + r.label + '</div>' +
            SETS.map(function (s) { return cell(r.vals[s.key], s.hi); }).join('') + '</div>';
        });
        html += '</div>';
      });
      html += '<div class="trow tbl__cta"><div class="tcell lab"></div>' + SETS.map(function (s) {
        return '<div class="tcell' + (s.hi ? ' hi' : '') + '"><div class="price">' + s.price +
          (s.priceNote ? ' <small>' + s.priceNote + '</small>' : '') + '</div>' +
          '<a class="buy" href="' + s.url + '">' + s.cta + '</a></div>';
      }).join('') + '</div>';
      root.innerHTML = html;
      bindGroups();
    }
    function bindGroups() {
      $$('.tgrp', root).forEach(function (g) {
        var b = root.querySelector('[data-b="' + g.dataset.g + '"]');
        var settle = function () { if (g.classList.contains('open')) b.classList.add('settled'); };
        b.addEventListener('transitionend', function (e) { if (e.propertyName === 'max-height') settle(); });
        b.style.maxHeight = b.scrollHeight + 'px';
        settle();
        g.addEventListener('click', function () {
          var willOpen = !g.classList.contains('open');
          b.classList.remove('settled');
          b.style.maxHeight = willOpen ? '0px' : b.scrollHeight + 'px';
          void b.offsetHeight;
          g.classList.toggle('open', willOpen);
          g.setAttribute('aria-expanded', String(willOpen));
          b.style.maxHeight = willOpen ? b.scrollHeight + 'px' : '0px';
          b.toggleAttribute('data-closed', !willOpen);
        });
      });
      var remeasure = function () {
        $$('.tgrp.open', root).forEach(function (g) {
          var b = root.querySelector('[data-b="' + g.dataset.g + '"]');
          if (b.classList.contains('settled')) return;
          b.style.maxHeight = 'none'; b.style.maxHeight = b.scrollHeight + 'px';
        });
      };
      addEventListener('resize', remeasure, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    }
    var units = $('[data-units]', sec);
    if (units) {
      $$('button', units).forEach(function (b) {
        b.addEventListener('click', function () {
          unit = b.dataset.u;
          $$('button', units).forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.u === unit)); });
          try { localStorage.setItem('gc-units', unit); } catch (e) {}
          render();
        });
        b.setAttribute('aria-pressed', String(b.dataset.u === unit));
      });
    }
    render();

    /* swipe affordance + arrows */
    var tw = $('.tscrollw', sec), tsc = tw && $('.tscroll', tw);
    if (tsc) {
      var prev = $('.tarrow--prev', tw), next = $('.tarrow--next', tw);
      var sync = function () {
        var max = tsc.scrollWidth - tsc.clientWidth;
        var end = tsc.scrollLeft >= max - 4;
        tw.classList.toggle('at-end', end);
        if (tsc.scrollLeft > 12) tw.classList.add('touched');
        var overflows = max > 8;
        [prev, next].forEach(function (b) { if (b) b.hidden = !overflows; });
        if (prev) prev.disabled = tsc.scrollLeft <= 4;
        if (next) next.disabled = end;
      };
      var stepBy = function (dir) {
        var col = $('.set', tw);
        var w = col ? col.getBoundingClientRect().width : 220;
        tsc.scrollBy({ left: dir * w, behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { stepBy(-1); });
      if (next) next.addEventListener('click', function () { stepBy(1); });
      tsc.addEventListener('scroll', sync, { passive: true });
      addEventListener('resize', sync, { passive: true });
      sync();
    }
  }

  /* ---------- reveal + parallax ---------- */
  var io = null, ioc = null, iob = null, parList = [], parBound = false;
  function reveals(scope) {
    if (soft()) return;
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.classList.add('in'); io.unobserve(el);
          if (el.style.transitionDelay) setTimeout(function () { el.style.transitionDelay = ''; }, 1400);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
      ioc = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); ioc.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      iob = new IntersectionObserver(function (es) {
        if (matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        es.forEach(function (e) { e.target.classList.toggle('on', e.isIntersecting); });
      }, { rootMargin: '-10% 0px -10% 0px', threshold: 0 });
    }
    var SEL = 'h2,h3,.eyebrow,.lead,.att,.badge,.logos,.press,.wb,.units,.orn,' +
      '.legend__i,.bitem,.trust__i,.quote,.set,.qa,.mode,.level__txt,.ugc';
    var groups = new Map();
    $$('.gcw section, .gcw .move', scope).forEach(function (sec) {
      $$(SEL, sec).forEach(function (el) {
        if (el.closest('.hero') || el.closest('.qa__a') || el.dataset.gcwRv) return;
        var k = el.parentElement;
        if (!groups.has(k)) groups.set(k, []);
        groups.get(k).push(el);
      });
    });
    groups.forEach(function (list) {
      list.forEach(function (el, i) {
        el.dataset.gcwRv = '1';
        el.classList.add('rv');
        if (list.length > 1) el.style.transitionDelay = Math.min(i * 55, 330) + 'ms';
        io.observe(el);
      });
    });
    $$('.moves__vis,.xmas__board,.unbox__vid,.pieces,.play__img,.level__vid,.move__vis,.mode__ph', scope)
      .forEach(function (el) { if (once(el, 'Rvc')) { el.classList.add('rvc'); ioc.observe(el); } });
    $$('.bwrap', scope).forEach(function (el) { if (once(el, 'Bw')) iob.observe(el); });
    document.documentElement.dataset.touch =
      matchMedia('(hover: hover) and (pointer: fine)').matches ? '0' : '1';

    parList = $$('.gcw [data-par]');
    if (parList.length && !parBound) {
      parBound = true;
      var ticking = false;
      var draw = function () {
        var vh = innerHeight;
        parList.forEach(function (el) {
          var p = el.parentElement.getBoundingClientRect();
          var off = (p.top + p.height / 2 - vh / 2) * -0.055;
          el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(1.14)';
        });
        ticking = false;
      };
      addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(draw); } }, { passive: true });
      addEventListener('resize', draw, { passive: true });
      draw();
    }
  }

  /* ---------- boot ---------- */
  function boot(scope) {
    scope = scope || document;

    $$('.gcw .stars', scope).forEach(function (s) { if (once(s, 'Star')) s.innerHTML = STAR + STAR + STAR + STAR + STAR; });
    $$('.gcw video[data-lazy]', scope).forEach(function (v) { if (once(v, 'Lazy')) vio.observe(v); });

    /* reviews rail */
    var rail = $('.gcw [data-ugc-rail]', scope);
    if (rail && once(rail, 'Rail')) {
      var dots = $$('[data-ugc-dots] button', rail.closest('.gcw'));
      var api = makeInfinite(rail, {
        start: Math.min(2, rail.children.length - 1),
        onMove: function (i) { dots.forEach(function (d, k) { d.classList.toggle('on', k === i); }); }
      });
      if (api) {
        $$('[data-rail]', rail.closest('.gcw')).forEach(function (b) {
          b.addEventListener('click', function () { b.dataset.rail === 'next' ? api.next() : api.prev(); });
        });
        dots.forEach(function (d, i) { d.addEventListener('click', function () { api.goTo(i); }); });
      }
    }

    /* the three feature clips are a grid on desktop and a rail on a phone */
    var strip = $('.gcw .feat3', scope);
    if (strip && once(strip, 'Feat')) {
      var mq = matchMedia('(max-width:900px)'), fapi = null;
      var sync = function () {
        if (mq.matches && !fapi) fapi = makeInfinite(strip, { start: 1 });
        else if (!mq.matches && fapi) { fapi.teardown(); fapi = null; }
      };
      mq.addEventListener('change', sync);
      var rt; addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(sync, 150); });
      sync();
    }

    /* comparison table */
    $$('.gcw [data-compare]', scope).forEach(function (sec) { if (once(sec, 'Cmp')) buildCompare(sec); });

    /* faq accordion (markup comes from Liquid, so it is there with JS off) */
    $$('.gcw .qa', scope).forEach(function (qa) {
      if (!once(qa, 'Qa')) return;
      var a = $('.qa__a', qa);
      var set = function () { a.style.maxHeight = qa.classList.contains('open') ? a.scrollHeight + 'px' : '0px'; };
      $('.qa__q', qa).addEventListener('click', function () { qa.classList.toggle('open'); set(); });
      set();
    });

    /* sticky CTA */
    var bar = $('.gcw [data-sticky]', scope) || $('.gcw [data-sticky]');
    if (bar && once(bar, 'Bar')) {
      var hero = $('.gcw .hero'), buy = document.getElementById('buy'), close = $('.gcw .move');
      if (hero) {
        var past = false, atOffer = false;
        var upd = function () { bar.classList.toggle('on', past && !atOffer); };
        new IntersectionObserver(function (es) { past = !es[0].isIntersecting; upd(); }, { threshold: 0 }).observe(hero);
        var seen = new Map();
        var off = new IntersectionObserver(function (es) {
          es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
          atOffer = Array.from(seen.values()).some(Boolean);
          upd();
        }, { threshold: 0 });
        [buy, close].filter(Boolean).forEach(function (el) { off.observe(el); });
      }
    }

    reveals(scope);
  }

  /* In-page CTAs scroll instead of jumping. The theme leaves scroll-behavior at auto and the
     namespaced stylesheet cannot reach <html> to change it, so the scroll happens here.
     Delegated from the document, so it also covers CTAs a section reload rebuilds. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.gcw a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;                      /* a bare "#" is left alone */
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  window.__gcwLP = { boot: boot, makeInfinite: makeInfinite };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
})();
